import React from 'react';
import noImageIcon from '../../../../assets/images/no_image.svg';
import { VideoThumbnail } from '../../../common/VideoThumbnail/VideoThumbnail';
import { isCheckStep } from '../BranchEdit/Steps/StepTypeCheck/StepTypeCheck';
import { BranchNodeCardCheckInfo } from './BranchNodeCardCheckInfo';
import { MemoryCards } from './MemoryCards/MemoryCards';
import { NodeCardStats } from './NodeCardStats/NodeCardStats';
import { TraitImages } from './TraitImages';

export function BranchNodeCard({
  storyGroup,
  branchNode,
  memorySlotData,
}) {
  const isLiveGroup = storyGroup === 'live' || storyGroup === 'liveprompt';
  const isLocationImg = branchNode.location?.image && !isLiveGroup;
  const decisionPoint = branchNode.links?.length > 0;
  const isCheck = isCheckStep(branchNode);

  return (
    <div className="card branchNodeCard" style={{ position: 'relative' }}>
      {branchNode.location?.video?.videoUrl ? (
        <VideoThumbnail
          videoUrl={branchNode.location.video.videoUrl}
          subtitleUrl={branchNode.location.video.subtitleUrl}
          videoSettings={branchNode.location.videoSettings}
          title={branchNode.location_title || 'Video'}
          fallbackImageUrl={isLocationImg ? branchNode.location?.image?.imageUrl : noImageIcon}
        />
      ) : (
        <div
          className="locationImg"
          title={`${branchNode.location_title ?? '-'}`}
          style={{
            backgroundImage: isLocationImg && `url(${branchNode.location?.image?.imageUrl ?? noImageIcon})`,
            backgroundSize: isLocationImg ? 'cover' : 'contain',
            backgroundRepeat: 'no-repeat',
          }}
        />
      )}
      <p className="text-left m-0 pt-0 description descriptionLocationImg">
        {branchNode.description}
      </p>
      {branchNode.type !== 'choice' && (
        <MemoryCards steps={branchNode.steps} />
      )}
      <NodeCardStats
        stepsCount={branchNode.steps_count || 0}
        wordsCount={branchNode.words_count || 0}
      />
      {decisionPoint && (
        <TraitImages
          answers={branchNode.answers}
        />
      )}
      {isCheck && (
        <BranchNodeCardCheckInfo
          memorySlotData={memorySlotData}
        />
      )}
    </div>
  );
}
